import EnvironmentGuard from 'src/components/EnvironmentGuard';
import DeploymentRingsList from './DeploymentRingsList';

const DeploymentRings = () => (
  <EnvironmentGuard>
    <DeploymentRingsList />
  </EnvironmentGuard>
);

export default DeploymentRings;
